export default "__VITE_ASSET__s1Md6x$z__"